
<fieldset class="rms-fieldset contact-card">
  <legend>{{ title }}</legend>

  <div class="options">
    @if (canEdit) {
      @if (edit) {
        <button mat-icon-button aria-label="Done" (click)="onDone()">
          <mat-icon>done</mat-icon>
        </button>
      }
      <button mat-icon-button aria-label="Toggle edit" (click)="toggleEdit()">
        <mat-icon>{{ edit ? 'close' : 'edit' }}</mat-icon>
      </button>
    }
  </div>

  <!-- Contact selector (if contacts exist) -->
  @if (hasContacts) {
    <div class="row selector">
      <div class="selector-left">
        <rms-select
          label="Select Contact"
          [options]="contactOptions"
          [(ngModel)]="selectedContactId"
          (ngModelChange)="loadFromSelected()"
          [disabled]="edit === true">
        </rms-select>
      </div>
      <div class="selector-right">
        <button mat-stroked-button type="button" (click)="newBlank()" [disabled]="!canEdit">New</button>
      </div>
    </div>
  } @else {
    <!-- No contacts? Show nothing here; form below will be blank -->
  }

  <!-- Form body -->
    <form #contactForm="ngForm" class="form-grid">

      <!-- Name row -->
      @if (showField('firstName') || showField('lastName')) {
      <div class="row two">
        @if (showField('firstName')) {
        @if (edit) {
        <rms-input label="First Name"
                   [ngModel]="form().firstName"
                   (ngModelChange)="setField('firstName', $event)"
                   name="firstName">
        </rms-input>
        } @else {
        <div class="display">
          <label>First Name</label>
          <div class="value">{{ form().firstName || '—' }}</div>
        </div>
        }
        }
        @if (showField('lastName')) {
        @if (edit) {
        <rms-input label="Last Name"
                   [ngModel]="form().lastName"
                   (ngModelChange)="setField('lastName', $event)"
                   name="lastName">
        </rms-input>
        } @else {
        <div class="display">
          <label>Last Name</label>
          <div class="value">{{ form().lastName || '—' }}</div>
        </div>
        }
        }
      </div>
      }

      @if (showField('company')) {
      <div class="row one">
        @if (edit) {
        <rms-input label="Company"
                   [ngModel]="form().company"
                   (ngModelChange)="setField('company', $event)"
                   name="company">
        </rms-input>
        } @else {
        <div class="display">
          <label>Company</label>
          <div class="value">{{ form().company || '—' }}</div>
        </div>
        }
      </div>
      }

      <!-- Contact info -->
      @if (showField('email') || showField('phone')) {
      <div class="row two">
        @if (showField('email')) {
        @if (edit) {
        <rms-input label="Email"
                   [ngModel]="form().email"
                   (ngModelChange)="setField('email', $event)"
                   name="email">
        </rms-input>
        } @else {
        <div class="display">
          <label>Email</label>
          <div class="value">{{ form().email || '—' }}</div>
        </div>
        }
        }
        @if (showField('phone')) {
        @if (edit) {
        <rms-input label="Phone"
                   [ngModel]="form().phone"
                   (ngModelChange)="setField('phone', $event)"
                   name="phone">
        </rms-input>
        } @else {
        <div class="display">
          <label>Phone</label>
          <div class="value">{{ form().phone || '—' }}</div>
        </div>
        }
        }
      </div>
      }

      <!-- Address -->
      @if (showField('street1')) {
      <div class="row one">
        @if (edit) {
        <rms-input label="Street 1"
                   [ngModel]="form().street1"
                   (ngModelChange)="setField('street1', $event)"
                   name="street1">
        </rms-input>
        } @else {
        <div class="display">
          <label>Street 1</label>
          <div class="value">{{ form().street1 || '—' }}</div>
        </div>
        }
      </div>
      }

      @if (showField('street2')) {
      <div class="row one">
        @if (edit) {
        <rms-input label="Street 2"
                   [ngModel]="form().street2"
                   (ngModelChange)="setField('street2', $event)"
                   name="street2">
        </rms-input>
        } @else {
        <div class="display">
          <label>Street 2</label>
          <div class="value">{{ form().street2 || '—' }}</div>
        </div>
        }
      </div>
      }

      @if (showField('city') || showField('state') || showField('postalCode')) {
      <div class="row three address-line">
        @if (showField('city')) {
        @if (edit) {
        <rms-input label="City"
                   [ngModel]="form().city"
                   (ngModelChange)="setField('city', $event)"
                   name="city">
        </rms-input>
        } @else {
        <div class="display">
          <label>City</label>
          <div class="value">{{ form().city || '—' }}</div>
        </div>
        }
        }
        @if (showField('state')) {
        @if (edit) {
        <rms-input label="State"
                   [ngModel]="form().state"
                   (ngModelChange)="setField('state', $event)"
                   name="state">
        </rms-input>
        } @else {
        <div class="display">
          <label>State</label>
          <div class="value">{{ form().state || '—' }}</div>
        </div>
        }
        }
        @if (showField('postalCode')) {
        @if (edit) {
        <rms-input label="Zip"
                   [ngModel]="form().postalCode"
                   (ngModelChange)="setField('postalCode', $event)"
                   name="postalCode">
        </rms-input>
        } @else {
        <div class="display">
          <label>Zip</label>
          <div class="value">{{ form().postalCode || '—' }}</div>
        </div>
        }
        }
      </div>
      }

      @if (showField('country')) {
      <div class="row one">
        @if (edit) {
        <rms-input label="Country"
                   [ngModel]="form().country"
                   (ngModelChange)="setField('country', $event)"
                   name="country">
        </rms-input>
        } @else {
        <div class="display">
          <label>Country</label>
          <div class="value">{{ form().country || '—' }}</div>
        </div>
        }
      </div>
      }

      @if (showField('messenger') || showField('notes')) {
      <div class="row two">
        @if (showField('messenger')) {
        @if (edit) {
        <rms-input label="Messenger"
                   [ngModel]="form().messenger"
                   (ngModelChange)="setField('messenger', $event)"
                   name="messenger">
        </rms-input>
        } @else {
        <div class="display">
          <label>Messenger</label>
          <div class="value">{{ form().messenger || '—' }}</div>
        </div>
        }
        }
        @if (showField('notes')) {
        @if (edit) {
        <rms-input label="Notes"
                   [ngModel]="form().notes"
                   (ngModelChange)="setField('notes', $event)"
                   name="notes">
        </rms-input>
        } @else {
        <div class="display">
          <label>Notes</label>
          <div class="value">{{ form().notes || '—' }}</div>
        </div>
        }
        }
      </div>
      }
      @for (key of dynamicFields; track key) {
      <div class="row one">
        @if (edit) {
        <rms-input [label]="prettifyLabel(key)"
                   [ngModel]="form()[key]"
                   (ngModelChange)="setField(key, $event)"
                   [name]="key">
        </rms-input>
        } @else {
        <div class="display">
          <label>{{ prettifyLabel(key) }}</label>
          <div class="value">{{ form()[key] || '—' }}</div>
        </div>
        }
      </div>
      }
    </form>

  <!-- Mailing label preview (optional) -->
  <!--
  <div class="mailing-label">
    @for (line of mailingLabel(); track $index) {
      <div class="label-line">{{ line }}</div>
    }
  </div>
  -->
</fieldset>
